import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage";
import ContactPage from "./pages/ContactPage";
import ProjectDetailsPage from "./pages/ProjectDetailsPage";
import FeedPage from "./pages/FeedPage";
import ShopPage from "./pages/ShopPage";
import ProjectPage from "./pages/ProjectPage";
import ResourcesPage from "./pages/ResourcesPage";
import ResourceDetailsPage from "./pages/ResourceDetailsPage";
import ProductsPage from "./pages/ProductsPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/contact" element={<ContactPage/> } />
        <Route path="/my-feed" element={<FeedPage/> } />
        <Route path="/shop" element={<ShopPage/> } />
        <Route path="/resources" element={<ResourcesPage/> } />
        <Route path="/resources/:id" element={<ResourceDetailsPage/> } />
        <Route path="/products" element={<ProductsPage/> } />
        <Route path="/project/:slug" element={<ProjectPage/> } />
        <Route path="/microinteractions" element={<ProjectDetailsPage/> } />
      </Routes>
    </Router>
  );
}

export default App;
